// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemEmpty_wrapper__6zVIV"};